<template>
  <div class="datepicker_section">
    <div class="detail_label">
      {{ titleLabel }}
    </div>
    <datepicker
      :placeholder="placeholderValue"
      :config="config"
      :id="pickerId"
      @on-change="customFormatter"
      :locale="ja"
      :value="value"
      class="start_datepicker"
    >
    </datepicker>
  </div>
</template>

<script>
import datepicker from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import japanese from 'flatpickr/dist/l10n/ja.js'

export default {
  props: {
    titleLabel: String,
    pickerId: String
  },
  data() {
    return {
      ja: japanese,
      config: {
        dateformat: 'YYYY/mm/DD',
        locale: japanese,
        maxDate: '9999'
      },
      value: '',
      placeholderValue: 'Select Date'
    }
  },
  computed: {},
  components: {
    datepicker
  },
  methods: {
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      event.target.value = year + '/' + month + '/' + day
      this.$emit('inputUpdate', event.target.value)
    }
  }
}
</script>
<style scoped>
.datepicker_section {
  width: 100%;
  padding-bottom: 15px;
  padding-left: 5%;
}
.start_datepicker {
  width: 50%;
}
.detail_label {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/logExportCompornents/datepickerSection.vue